import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

let total_div = [];

class InfiniteScrollPagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Laoding: true,
      data: [],
      page: 0,
      perpage: 10,
      fromDate: props.startDate,
      toDate: props.endDate,
      sortColumn: props.sortColumn,
      sortDirection: props.sortDirection,
      isApiCallProgress: false,
      lastPage: 1,
      showAPILoader: false,
      endResult: false,
      status: ''
    };

    // This binding is necessary to make `this` work in the callback
    this.onLoadEventListner = this.onLoadEventListner.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  checkPropsChange = () => {
    if (this.props.startDate != this.state.startDate) {
      total_div = [];
      this.setState({ startDate: this.props.startDate, data: [], page: 0 });
    }
    if (this.props.endDate != this.state.endDate) {
      total_div = [];

      this.setState({ endDate: this.props.endDate, data: [], page: 0 });
    }
    if (this.props.sortColumn != this.state.sortColumn) {
      total_div = [];

      this.setState({ sortColumn: this.props.sortColumn, data: [], page: 0 });
    }
    if (this.props.sortDirection != this.state.sortDirection) {
      total_div = [];

      this.setState({
        sortDirection: this.props.sortDirection,
        data: [],
        page: 0
      });
    }
    if (this.props.status != this.state.status) {
      total_div = [];

      this.setState({ status: this.props.status, data: [], page: 0 });
    }
  };

  loadMore = () => {
    this.props
      .call_api(
        this.state.page,
        this.state.perpage,
        this.state.fromDate,
        this.state.toDate,
        this.state.sortColumn,
        this.state.sortDirection,
        this.state.status
      )
      .then(data => {
        this.setState({ lastPage: data.dataPage.totalPages });
        this.setState({ isApiCallProgress: false, showAPILoader: false });

        data.data.map((each, index) => {
          total_div.push(
            <this.props.Component
              key={this.state.page.toString() + index.toString()}
              each={each}
            />
          );
        });
        this.setState({ data: total_div });
      })
      .catch(this.setState({ isApiCallProgress: true }));
  };

  onLoadEventListner = () => {
    this.setState({ Laoding: false });
    window.addEventListener('scroll', () => {
      if (
        window.scrollY + window.innerHeight >=
        document.documentElement.scrollHeight
      ) {
        if (
          !this.state.isApiCallProgress &&
          parseInt(this.state.page) < parseInt(this.state.lastPage)
        ) {
          this.setState({ isApiCallProgress: true, endResult: false });
          this.setState({ page: parseInt(this.state.page) + 1 });
          this.loadMore();
        } else {
          if (parseInt(this.state.page) < parseInt(this.state.lastPage)) {
            this.setState({ showAPILoader: true, endResult: false });
          } else {
            this.setState({ endResult: true });
          }
        }
      }
    });
  };
  render() {
    this.checkPropsChange();
    return (
      <>
        <div onLoad={this.state.Laoding ? this.onLoadEventListner() : null}>
          {this.state.data}
        </div>
        <div className="text-center mx-auto h-3 py-3 my-3">
          {this.state.showAPILoader || this.state.isApiCallProgress ? (
            <CircularProgress />
          ) : null}
        </div>
        {this.state.endResult ? (
          <div className="text-center pb-1 font-roboto font-normal ">
            No More Data to Show!
          </div>
        ) : null}
      </>
    );
  }
}

export default InfiniteScrollPagination;
